import React from 'react';
import { Link } from 'react-router-dom';

import { paths } from 'config/path_helpers';

import { Metric } from '@magoosh/lib/contentful_contents/types';
import { SchoolProfileCategory } from '@schools/app/types';

interface Props {
  category: SchoolProfileCategory;
  currentMetric: Metric;
  metrics: Metric[];
  preview: boolean;
}

const MetricsList: React.FC<Props> = (props) => {
  return (
    <div>
      {
        (props.metrics || []).map((metric, idx) => (
          <div key={idx} style={{ marginBottom: 2 }}>
            {
              metric.slug === props.currentMetric?.slug ? (
                <div>
                  <strong>{metric.name}</strong>
                </div>
              ) : (
                <Link to={paths.admissions.schoolProfileCategoryMetric(metric.slug, props.category?.slug, props.preview)}>
                  {metric.name}
                </Link>
              )
            }
          </div>
        ))
      }
    </div>
  )
};

export default MetricsList;
